import { render, staticRenderFns } from "./SubProduct.vue?vue&type=template&id=83578082&"
import script from "./SubProduct.vue?vue&type=script&lang=js&"
export * from "./SubProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports